import { render } from "./CombatLogDeaths.vue?vue&type=template&id=0dc71652"
import script from "./CombatLogDeaths.vue?vue&type=script&lang=js"
export * from "./CombatLogDeaths.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__